import React from 'react';
import { getAegisAiDocumentHtml } from '../../../Services/AegisAiDocumentsService';

// Same shape as useSourceExtraction, so the review popup can show and edit a document the same way.
const IDLE = { status: '', text: '', rawText: '', cleaning: false, pages: [], result: null, error: '' };

// Loads a PDF/DOCX ({ file } or { documentId }) as editable HTML; a new source aborts the old request.
export default function useDocumentHtml(token, source) {
    const [state, setState] = React.useState(IDLE);
    const [attempt, setAttempt] = React.useState(0);

    React.useEffect(() => {
        if (!source || !token) {
            setState(IDLE);
            return undefined;
        }
        
        const controller = new AbortController();
        setState({ ...IDLE, status: source.enableOcr ? 'Analyzing visual document with Vision AI (Deep OCR)...' : 'Opening document for editing...' });
        getAegisAiDocumentHtml(token, source, controller.signal)
            .then((response) => setState(response?.is_success
                ? { ...IDLE, text: response.data?.Html || '', result: {} }
                : { ...IDLE, error: response?.message || 'Could not open this document' }))
            .catch((error) => {
                if (error.name !== 'AbortError') setState({ ...IDLE, error: 'Could not open this document' });
            });
        return () => controller.abort();
    }, [token, source, attempt]);

    const retry = React.useCallback(() => setAttempt((count) => count + 1), []);
    return { ...state, retry };
}
